import { render, staticRenderFns } from "./Examens.vue?vue&type=template&id=aa37ced2&scoped=true&"
import script from "./Examens.vue?vue&type=script&lang=ts&"
export * from "./Examens.vue?vue&type=script&lang=ts&"
import style0 from "./Examens.vue?vue&type=style&index=0&id=aa37ced2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa37ced2",
  null
  
)

export default component.exports